<main class="main-wrap-ng">
  <div class="content-blk">
    <div class="container">
      <form [formGroup]="signUpForm" (ngSubmit)="onSubmit(signUpForm)" autocomplete="off">
        <div class="form-background">
          <table>
            <tbody>
              <tr class="row-1">
                <td class="row-1-col-1 border-right">
                  Form<strong> W-9</strong>
                  <br />
                  (Rev. October 2018)
                  <br />
                  <br />
                  Department of the Treasury
                  <br />
                  Internal Revenue Service
                </td>
                <td class="row-1-col-2 border-right">
                  <strong>Request for Taxpayer</strong>
                  <br />
                  <strong>Identification Number and Certification</strong>
                  <br />
                  <br />
                  ▶ Go to <i>
                    <a href="https://www.irs.gov/forms-pubs/about-form-w-9"
                       target="_blank">www.irs.gov/FormW9</a>
                  </i> for instructions and the latest information.
                </td>
                <td class="row-1-col-3">
                  Give form to the
                  <br />
                  requester. Do not
                  <br />
                  send to the IRS.
                  <br />
                </td>
              </tr>


            </tbody>
          </table>
          <table>
            <tbody>
              <tr class="row-2">
                <td rowspan="6" class="rotate border-right">
                  <div>
                    See Specific Instructions on page 3.
                    <br />
                    Print or type
                  </div>
                </td>
                <td colspan="2">
                  <strong class="bolder-text">1</strong> Name (as shown on your income tax return). Name is required on
                  this line; do not leave this line blank.
                  <span class="required-field"
                        *ngIf="!f.Name.valid && f.Name.touched && (f.Name.pristine || f.Name.dirty)">
                    *Required
                  </span>
                  <br />
                  <input class="input-text-blue" formControlName="Name">
                </td>
              </tr>
              <tr class="row-3">
                <td colspan="2">
                  <strong class="bolder-text">2</strong> Business name/disregarded entity name, if different from above
                  <span class="required-field"
                        *ngIf="!f.BusinessName.valid && f.BusinessName.touched && (f.BusinessName.pristine || f.BusinessName.dirty)">
                    *Required
                  </span>
                  <br />
                  <input class="input-text-blue" formControlName="BusinessName">
                </td>
              </tr>
              <tr class="row-4">
                <td class="border-right" style="width: 70%;">
                  <strong class="bolder-text">3</strong> Check appropriate box for federal tax classification of the
                  person whose name is entered on line 1.
                  Check only <strong class="bolder-text">one</strong> of the following seven boxes.
                  <br />
                  <br />
                  <label>
                    <input type="checkbox" formControlName="Individual" (change)="onCheckboxChange($event, 'Individual')" value="Individual" /> <span class="margin-right-20">
                      Individual/sole proprietor or
                      single-member LLC
                    </span>
                  </label>
                  <label> <input type="checkbox" formControlName="CCorporation" (change)="onCheckboxChange($event, 'CCorporation')" value="CCorporation" /> <span class="margin-right-20">C Corporation</span></label>
                  <label> <input type="checkbox" formControlName="SCorporation" (change)="onCheckboxChange($event, 'SCorporation')" value="SCorporation" /> <span class="margin-right-20">S Corporation</span></label>
                  <label> <input type="checkbox" formControlName="Partnership" (change)="onCheckboxChange($event, 'Partnership')" value="Partnership" /> <span class="margin-right-20">Partnership</span></label>
                  <label> <input type="checkbox" formControlName="Trust" (change)="onCheckboxChange($event, 'Trust')" value="Trust" /> <span class="margin-right-20">Trust/estate</span></label>
                  <br />
                  <br />
                  <label>
                    <input type="checkbox" formControlName="LLC" (change)="onCheckboxChange($event, 'LLC')" name="Classification" value="LLC" />
                    Limited liability company. Enter the tax classification (C=C corporation, S=S corporation,
                    P=Partnership) ▶
                    <input type="text" class="input-text-line" formControlName="TaxClassification" />
                  </label>
                  <br />
                  <p style="font-size: 12px; line-height: 15px;" class="margin-left-20">
                    <strong class="bolder-text">Note:</strong> Check the appropriate box in the line above for the tax
                    classification of the single-member owner.
                    Do not check LLC if the LLC is classified as a single-member LLC that is disregarded from the
                    owner unless
                    the owner of the LLC is another LLC that is not disregarded from the owner for U.S.
                    federal tax purposes. Otherwise, a single-member LLC that
                    is disregarded from the owner should check the appropriate box for the tax classification of its
                    owner.
                  </p>
                  <br />
                  <br />
                  <label style="width: 100%;">
                    <input type="checkbox" formControlName="Other" (change)="onCheckboxChange($event, 'Other')" value="Other" /> Other (see instructions) ▶
                    <input class="input-text-line" formControlName="OtherText">
                  </label>
                </td>
                <td>
                  <strong class="bolder-text">4</strong> Exemptions (codes apply only to
                  certain entities, not individuals; see
                  instructions on page 3):
                  <br />
                  <br />
                  <br />
                  Exempt payee code (if any)
                  <input class="input-text-line" formControlName="ExepmtPayeeCode">
                  <br />
                  <br />
                  <br />
                  Exemption from FATCA reporting code (if any)
                  <input class="input-text-line" formControlName="FATCACode">
                  <br />
                  <br />
                  <br />
                  <small> (Applies to accounts maintained outside the U.S.)</small>
                </td>
              </tr>
              <tr class="row-5">
                <td class="border-right">
                  <strong class="bolder-text">5</strong> Address (number, street, and apt. or suite no.) See
                  instructions.
                  <span class="required-field"
                        *ngIf="!f.Address1.valid && f.Address1.touched && (f.Address1.pristine || f.Address1.dirty)">
                    *Required
                  </span>
                  <br />
                  <input class="input-text-blue" formControlName="Address1">
                </td>
                <td rowspan="2">
                  Requester’s name and address (optional)
                  <br />
                  <textarea rows="5" class="input-text-blue" formControlName="RequestorName"></textarea>
                </td>
              </tr>
              <tr class="row-6">
                <td class="border-right">
                  <strong class="bolder-text">6</strong> City, state, and ZIP code
                  <span class="required-field"
                        *ngIf="!f.Address2.valid && f.Address2.touched && (f.Address2.pristine || f.Address2.dirty)">
                    *Required
                  </span>
                  <br />
                  <input class="input-text-blue" formControlName="Address2">
                </td>
              </tr>
              <tr class="row-7">
                <td colspan="2">
                  <strong class="bolder-text">7</strong> List account number(s) here (optional)
                  <br />
                  <input class="input-text-blue" formControlName="LAN">
                </td>
              </tr>
            </tbody>
          </table>
          <table>
            <tbody>
              <tr class="row-8">
                <td colspan="3" class="row-8-col-1 parts-header">
                  <span class="black-background">Part I</span>Taxpayer Identification Number (TIN)
                </td>
              </tr>
              <tr class="row-9">
                <td width="75%">
                  Enter your TIN in the appropriate box. The TIN provided must match the name given on line 1 to avoid
                  backup withholding. For individuals, this is generally your social security number (SSN). However, for
                  a
                  resident alien, sole proprietor, or disregarded entity, see the instructions for Part I, later. For
                  other
                  entities, it is your employer identification number (EIN). If you do not have a number, see How to get
                  a
                  TIN, later.
                  <br />
                  <br />
                  <strong class="bolder-text">Note:</strong> If the account is in more than one name, see the
                  instructions for line 1. Also see What Name and
                  Number To Give the Requester for guidelines on whose number to enter.
                </td>
                <td>
                  <div>
                    <div class="skey">Social security number</div>
                    <input class="input-text-blue" formControlName="SSN" placeholder="XXX-XX-XXXX "  mask="000-00-0000">
                  </div>
                  <br />
                  <br />
                  <div class="bolder-text">
                    or
                  </div>
                  <br />
                  <br />
                  <div>
                    <div class="skey">Employer identification number</div>
                    <input class="input-text-blue" formControlName="EIN" placeholder="XXX-XXXXXX"  mask="000-000000">
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table>
            <tbody>
              <tr class="row-10">
                <td colspan="4" class="row-10-col-1 parts-header">
                  <span class="black-background">Part II</span>Certification
                </td>
              </tr>
              <tr class="row-11">
                <td class="row-11-col-1" colspan="4">
                  Under penalties of perjury, I certify that:
                  <br />
                  <br />
                  1. The number shown on this form is my correct taxpayer identification number (or I am waiting for a
                  number to be issued to me); and
                  <br />
                  2. I am not subject to backup withholding because: (a) I am exempt from backup withholding, or (b) I
                  have not been notified by the Internal Revenue
                  Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest
                  or dividends, or (c) the IRS has notified me that I am
                  no longer subject to backup withholding; and
                  <br />
                  3. I am a U.S. citizen or other U.S. person (defined below); and
                  <br />
                  4. The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is
                  correct.
                  <br />
                  <strong class="bolder-text">Certification instructions.</strong> You must cross out item 2 above if
                  you have been notified by the IRS that you are currently subject to backup withholding because
                  you have failed to report all interest and dividends on your tax return. For real estate transactions,
                  item 2 does not apply. For mortgage interest paid,
                  acquisition or abandonment of secured property, cancellation of debt, contributions to an individual
                  retirement arrangement (IRA), and generally, payments
                  other than interest and dividends, you are not required to sign the certification, but you must
                  provide your correct TIN. See the instructions for Part II, later.
                </td>
              </tr>
              <tr class="row-12">
                <td class="row-12-col-1 border-right" width="5%">
                  Sign
                  Here
                </td>
                <td class="row-12-col-2" width="10%">
                  Signature of
                  <br />
                  U.S. person ▶
                </td>
                <td class="row-12-col-2">
                  <!-- <input class="input-text-line" formControlName="Signature"> -->
                  <img *ngIf="signatureImage" [src]="signatureImage" width="100px" height="50px">
                  <br />
                  <a href="javascript:void(0)" (click)="fn_OpenSignaturePad()">Make a Signature</a>
                </td>
                <td class="row-12-col-3">
                  <br />
                  Date ▶
                  <input  class="input-text-blue"   formControlName="DateSigned" disabled>
                </td>
              </tr>
              <tr class="row-12">
                <td class="row-11-col-2" colspan="4">
                  <button class="mat-btn" mat-raised-button [disabled]="signUpForm.invalid">Submit</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
    </div>
  </div>
</main>

<br />
<br />
